import * as React from "react";

import {cs}                  from "@Common/react/chain-services";
import {cascadeSum}          from "@Common/utils/cascade";
import {normalizeTinyNumber} from "@Common/utils/math/normalize-tiny-number";

import {CartSummaryTable} from "./cart-summary-table";

export const Summary = ({store, next}) => cs(
    ({}) => {
        const cart = store.cart || {};
        const {items} = cart || {};

        const productsTotal = cascadeSum(items, "[*].itemTotals[*].amount", (amount,{},{2:p}) => (p.type !== "promoCode" ? 1 : -1) * amount);
        const billingTotal = cascadeSum(cart, "appliedPayments.billing[*].amount");

        const creditAttrs = [
            {
                label: "Store Credit",
                attr: "storeCredits",
            },
            {
                label: "Voucher",
                attr: "vouchers",
            },
            {
                label: "Ad Budget",
                attr: "adBudgets",
            },
            {
                label: "Copay",
                attr: "copays",
            },
        ].map(({label, attr}) => {
            const amount = cascadeSum(cart, `appliedCredits.${attr}[*].amount`, (a) => +a);
            return amount && ({
                label,
                amount,
                isCredit: true,
            });
        }).filter(v=>v);

        const creditTotal = cascadeSum(creditAttrs, "[*].amount");

        const balance = productsTotal - creditTotal;
        const remain = balance - billingTotal;

        return next({
            remain: normalizeTinyNumber(remain),
            productsTotal,
            balance,
            render: ({creditCards}) => CartSummaryTable({
                cart,
                items,
                billingTotal,
                balance,
                creditCards,
                creditAttrs,
            })
        });
    }
);

